import ModalTeam from '../components/modal-team';

class TeamModal {
	constructor(el) {
		this.el = el;

		this.initializeModals();
	}

	initializeModals = () => {
		const teamMemberWrappers = this.el.querySelectorAll('.block-team__team-member-wrapper');
        
		teamMemberWrappers.forEach(t => {
			const btnModalTeam = t.querySelector('.js__team-modal');
			const modalTeam = t.querySelector('.block-team-modal').innerHTML;
			if (btnModalTeam) {
				btnModalTeam.addEventListener('click', () => {
					ModalTeam.show(
						modalTeam
					);
				});
			}
		})

	};

}

export default TeamModal;